import React from "react"
import {
  red500, pink500, purple500, deepPurple500, indigo500, blue500, lightBlue500, cyan500,
  teal500, green500, lightGreen500, lime500, yellow500, amber500, orange500, deepOrange500
}
  from "material-ui/styles/colors"
interface IProps {
  handleSelect(color: string): void
}

const reactColorList = [
  red500, pink500, purple500, deepPurple500, indigo500, blue500, lightBlue500, cyan500,
  teal500, green500, lightGreen500, lime500, yellow500, amber500, orange500, deepOrange500
]

const reactColorMatrix = [
  [reactColorList[0], reactColorList[1], reactColorList[2], reactColorList[3], reactColorList[4], reactColorList[5], reactColorList[6], reactColorList[7]],
  [reactColorList[8], reactColorList[9], reactColorList[10], reactColorList[11], reactColorList[12], reactColorList[13], reactColorList[14], reactColorList[15]]
]

const ColorPicker: React.SFC<IProps> = (props: IProps) => {
  return (
    <div>
      {reactColorMatrix.map((group, index) =>
        <div style={{ height: 20, display: "flex", width: "fit-content" }} key={index}>
          {group.map((color, index) =>
            <div
              data-intercom-target={`Positions-Btn-SelectColot${index+1}`}
              style={{ backgroundColor: color, width: 20, height: 20, cursor: "pointer", flex: 1 }}
              key={color}
              onClick={() => props.handleSelect(color)}
            />
          )}
        </div>
      )}
    </div>
  )
}

export function getDefaultColor(existingPositions) {
  let colorIndex = 0
  let returnColor = reactColorList[colorIndex]

  while (isColorUsed(returnColor, existingPositions) && colorIndex < reactColorList.length) {
    returnColor = reactColorList[colorIndex]
    colorIndex++
  }

  return returnColor
}

function isColorUsed(color, positions) {
  let returnVal = false

  if (positions) {
    positions.forEach((position, index) => {
      if (color === position.Color) {
        returnVal = true
      }
    })
  }

  return returnVal
}

export default ColorPicker